// ============================================
// helpersExpedientes.js
// ============================================
// Constantes y helpers compartidos por FichaExpediente y los modales.
// La paleta replica la usada en client/src/Expedientes.js (lista) para
// que la ficha de detalle se sienta del mismo modulo.

import React from 'react';
import { API_BASE_CLI } from '../helpersClientes';

export { API_BASE_CLI };

export const COLOR_BEEP_AZUL = '#185FA5';
export const COLOR_BEEP_LIMA = '#94b803';
export const COLOR_OSCURO    = '#270f2b';
export const COLOR_FONDO     = '#f3f4f4';
export const COLOR_BORDE     = '#e5e7eb';
export const COLOR_GRIS      = '#5e666e';
export const COLOR_GRIS_CL   = '#9aa0a6';
export const COLOR_OK        = '#1D9E75';
export const COLOR_PELIGRO   = '#dc2626';

export const FF = "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

// TRAZABILIDAD (fix "Alguien", 2026-07-11): nunca inventar autor. Sin firma:
// si la nota delata un proceso del sistema (migracion de flujos), se dice; si
// no, la verdad honesta — la fila es anterior al fix de firmas. Compartido por
// TabHistorial (ficha) y la pestaña Actividad global.
export function etiquetaAutor(usuarioNombre, nota) {
  if (usuarioNombre) return usuarioNombre;
  if (typeof nota === 'string' && /migracion/i.test(nota)) return 'Sistema (migracion de flujos)';
  return 'No registrado (anterior al fix de firmas)';
}

// Visual de los 19 estados del funnel + cierres legacy (espejo de Expedientes.js).
// Mantener sincronizado con el ESTADO_VISUAL_OPORTUNIDAD de client/src/Expedientes.js.
export const ESTADO_VISUAL_OPORTUNIDAD = {
  nuevo_interes:        { color: '#93C5FD', label: 'Contexto del proyecto', descripcion: 'Datos del interes del cliente' },
  solicitud_cliente:    { color: '#3B82F6', label: 'Solicitud Cliente',    descripcion: 'Cliente existente solicito servicio' },
  contactado:           { color: '#2563EB', label: 'Contactado',           descripcion: 'Primer contacto realizado' },
  visita_programada:    { color: '#1D4ED8', label: 'Visita Programada',    descripcion: 'Visita agendada con cliente' },
  visita_realizada:     { color: '#10B981', label: 'Visita Realizada',     descripcion: 'Visita tecnica completada' },
  en_cotizacion:        { color: '#F97316', label: 'En Cotizacion',        descripcion: 'Cotizacion en preparacion' },
  cotizacion_aprobada:  { color: '#22C55E', label: 'Cotizacion Aprobada',  descripcion: 'Cliente aprobo la cotizacion' },
  esperando_anticipo:   { color: '#FBBF24', label: 'Esperando Anticipo',   descripcion: 'Esperando pago anticipado del cliente' },
  anticipo_recibido:    { color: '#16A34A', label: 'Anticipo Recibido',    descripcion: 'Anticipo confirmado en banco' },
  en_compras:           { color: '#A855F7', label: 'En Compras',           descripcion: 'Solicitando material faltante' },
  almacen_revision:     { color: '#C084FC', label: 'Almacen Revision',     descripcion: 'Almacen revisando disponibilidad' },
  material_completo:    { color: '#15803D', label: 'Material Completo',    descripcion: 'Listo para programar' },
  en_programacion:      { color: '#0EA5E9', label: 'En Programacion',      descripcion: 'Generando ruta y agenda' },
  programado:           { color: '#0284C7', label: 'Programado',           descripcion: 'Fecha y tecnico asignados' },
  en_proceso:           { color: '#EA580C', label: 'En Proceso',           descripcion: 'Instalacion o servicio en curso' },
  pendiente_finiquito:  { color: '#FBBF24', label: 'Pendiente Finiquito',  descripcion: 'Esperando pago final' },
  pagado_completo:      { color: '#15803D', label: 'Pagado Completo',      descripcion: 'Pago total recibido' },
  en_garantia:          { color: '#10B981', label: 'En Garantia',          descripcion: 'Periodo de garantia activo' },
  archivado:            { color: '#6B7280', label: 'Archivado',            descripcion: 'Expediente cerrado' },
  // Cierres legacy (perdido / cancelado siguen vivos para /cerrar-perdido y /descartar)
  perdido:              { color: '#dc2626', label: 'Perdido',              descripcion: 'No se vendio' },
  cancelado:            { color: '#9ca3af', label: 'Descartado',           descripcion: 'Duplicado o error' },
  // FLUJOS-FIJOS (Entrega 1): pasos de los 3 flujos (espejo de mig_066).
  visita:               { color: '#1D4ED8', label: 'Levantamiento',        descripcion: 'Levantamiento tecnico del sitio (opcional)' },
  solicitud:            { color: '#3B82F6', label: 'Solicitud',            descripcion: 'Que pide el cliente' },
  diagnostico:          { color: '#0EA5E9', label: 'Diagnostico',          descripcion: 'Diagnostico del equipo' },
  cotizacion:           { color: '#F97316', label: 'Cotizacion',           descripcion: 'Cotizacion autorizada vinculada' },
  anticipo:             { color: '#FBBF24', label: 'Anticipo',             descripcion: 'Pago registrado' },
  preparacion:          { color: '#A855F7', label: 'Preparacion',          descripcion: 'Checklist de material' },
  compra:               { color: '#C084FC', label: 'Compra',               descripcion: 'Faltantes en compra' },
  almacen:              { color: '#15803D', label: 'Almacen',              descripcion: 'Salida de material' },
  instalacion:          { color: '#EA580C', label: 'Instalacion',          descripcion: 'Trabajo en sitio' },
  reparacion:           { color: '#DC2626', label: 'Ejecucion del servicio', descripcion: 'Servicio tecnico realizado' },
  entrega:              { color: '#10B981', label: 'Entrega',              descripcion: 'Conformidad del cliente' },
  facturacion:          { color: '#6366F1', label: 'Facturacion',          descripcion: 'Factura emitida' },
  cerrado:              { color: '#16A34A', label: 'Cerrado',              descripcion: 'Flujo completado (ganado)' },
};

export const TIPO_EXPEDIENTE_VISUAL = {
  anexo:              { color: '#ea580c', label: 'Anexo',     icono: '↳', descripcion: 'Trabajo extra durante una obra activa' },
  garantia:           { color: '#dc2626', label: 'Garantia',  icono: '⚠', descripcion: 'Reclamo bajo garantia de un servicio cerrado' },
  servicio_postventa: { color: '#185FA5', label: 'Postventa', icono: '↻', descripcion: 'Nueva venta a un cliente con expediente archivado' },
};

export const CIERRE_VISUAL = {
  ganado:     { color: '#1D9E75', label: 'Ganado' },
  perdido:    { color: '#dc2626', label: 'Perdido' },
  descartado: { color: '#9ca3af', label: 'Descartado' },
};

// Normaliza el rol y devuelve true si el usuario es 'direccion'.
// Acepta 'Direccion', 'direccion', 'Direccion' (con/sin acento).
export function esRolDireccion(usuario) {
  const r = usuario?.rol;
  if (!r || typeof r !== 'string') return false;
  const norm = r.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  return norm === 'direccion';
}

export function authHeaders() {
  try {
    const t = localStorage.getItem('beep_token');
    return t ? { Authorization: `Bearer ${t}` } : {};
  } catch { return {}; }
}

export function fmtMoneda(n) {
  if (n == null || isNaN(Number(n))) return null;
  return Number(n).toLocaleString('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtFecha(f) {
  if (!f) return '';
  try {
    const d = new Date(f);
    return d.toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' });
  } catch { return String(f); }
}

// Estilos base reutilizables
export const inputStyle = {
  width: '100%', padding: '11px 12px',
  border: `1px solid ${COLOR_BORDE}`, borderRadius: 8,
  // 16px evita el auto-zoom de iOS al enfocar (mismo cuidado del fix movil de
  // captura); minHeight 44 = tactil-safe.
  fontSize: 16, minHeight: 44, fontFamily: FF, color: COLOR_OSCURO,
  outline: 'none', boxSizing: 'border-box', background: '#fff',
};

export const botonPrimario = {
  background: COLOR_BEEP_LIMA, color: '#fff', border: 'none',
  borderRadius: 10, padding: '10px 18px', fontSize: 13, fontWeight: 700,
  // tactil >= 44 (regla del proyecto; estaban en 40, medido en el modal de editar)
  fontFamily: FF, cursor: 'pointer', minHeight: 44,
};

export const botonSecundario = {
  background: '#fff', color: COLOR_GRIS, border: `1px solid ${COLOR_BORDE}`,
  borderRadius: 10, padding: '10px 16px', fontSize: 13, fontWeight: 600,
  fontFamily: FF, cursor: 'pointer', minHeight: 44,
};

export const botonPeligro = {
  background: COLOR_PELIGRO, color: '#fff', border: 'none',
  borderRadius: 10, padding: '10px 18px', fontSize: 13, fontWeight: 700,
  fontFamily: FF, cursor: 'pointer', minHeight: 44,
};

export function ToastFlotante({ tipo = 'ok', children }) {
  return (
    <div style={{
      position: 'fixed', bottom: 28, left: '50%', transform: 'translateX(-50%)',
      background: tipo === 'ok' ? COLOR_BEEP_LIMA : COLOR_PELIGRO,
      color: '#fff', padding: '12px 22px', borderRadius: 10,
      fontSize: 14, fontWeight: 600, fontFamily: FF, zIndex: 6500,
      boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
    }}>{children}</div>
  );
}

// Shell de modal centrado, con overlay y body lock.
// FLUJOS-FIJOS (veto de don-benito): Escape cierra el modal AQUI, centralizado,
// para que todo consumidor lo herede (los modales hermanos que ya tenian su
// propio listener siguen funcionando: onClose es idempotente).
export function ShellModal({ children, onClose, ancho = 480, esCelular }) {
  React.useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape' && typeof onClose === 'function') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  // MOVIL-GUARDAR (2026-09-12): bloquear el scroll del fondo mientras el modal esta abierto.
  // Ademas de higiene (el fondo ya no se arrastra debajo del formulario), marcar
  // <html> con overflow:hidden es la SENAL que el Dashboard ya usa para esconder la barra
  // inferior — y ahora tambien el boton flotante del asistente, que tapaba controles.
  React.useEffect(() => {
    const previo = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    return () => { document.documentElement.style.overflow = previo; };
  }, []);
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)',
        zIndex: 5500, display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        padding: esCelular ? 0 : 20, fontFamily: FF,
      }}
    >
      {/* MOVIL-GUARDAR: el alto va por CLASE, no inline, porque los estilos inline no cascadean
          y necesitamos `vh` como respaldo y `dvh` encima donde se soporte. Con `vh` a secas el
          modal media el viewport GRANDE: con la barra del navegador Android visible, o con el
          teclado abierto, su parte de abajo (donde vive Guardar) quedaba FUERA de la pantalla y
          no habia forma de alcanzarla. Mismo patron ya usado en el modal de Nuevo expediente. */}
      <style>{`
        .exp-shell-alto-movil { max-height: 92vh; max-height: 92dvh; }
        .exp-shell-alto-desktop { max-height: 88vh; max-height: 88dvh; }
      `}</style>
      <div
        onClick={(e) => e.stopPropagation()}
        className={esCelular ? 'exp-shell-alto-movil' : 'exp-shell-alto-desktop'}
        style={{
          background: '#fff',
          borderRadius: esCelular ? '14px 14px 0 0' : 14,
          width: '100%', maxWidth: ancho,
          display: 'flex', flexDirection: 'column',
          minHeight: 0,
          overflow: 'hidden',
          alignSelf: esCelular ? 'flex-end' : 'center',
          boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
        }}
      >
        {children}
      </div>
    </div>
  );
}
